import Column from "@amzn/meridian/column";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import meridianColors from "@amzn/meridian-tokens/base/color";
import Row from "@amzn/meridian/row";
import Coachmark from "@amzn/meridian/coachmark";
import Text from "@amzn/meridian/text";
import { isValidRange } from "src/utils/numberUtil";
import _ from "lodash";
import Link from "@amzn/meridian/link";
import PaginationWithDropdown from "src/components/pages/audit/paginationWithDropdown";
import {
  GroundTruthField,
  resetListViewPage,
  setCurrentPage,
  setItemPerPage,
} from "src/store/modelLifeCycleGroundTruthSlice";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { useNavigate } from "react-router-dom";
import {
  getGroundTruthDataListViewReviewer,
  getGroundTruthDataListViewStatus,
} from "src/components/shared/groundTruth/listView/listViewUtils";

interface ListViewTableProps {
  navigateUrl: string;
  getListViewId: string;
}

const ListViewTable = ({ navigateUrl, getListViewId }: ListViewTableProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tableHeaderRowNames = ["Source ID", "Status", "Reviewer"];
  const {
    groundTruthDataListView,
    currentPage,
    itemsPerPage,
    getListViewLoading,
    groundTruthDataTotalCount,
    groundTruthDataTotalReviewedCount,
  } = useAppSelector((state) => state.modelLifeCycleGroundTruthSlice);
  const { token, alias, ldap } = useAppSelector((state) => state.user);

  // triggerred when review page redirect to list view
  useEffect(() => {
    dispatch(resetListViewPage());
  }, []);

  const firstVisibleIndex = (currentPage - 1) * itemsPerPage;
  const lastVisibleIndex = Math.min(
    groundTruthDataListView.length,
    firstVisibleIndex + itemsPerPage - 1,
  );
  const numberOfPages = Math.ceil(groundTruthDataListView.length / itemsPerPage);

  const { selectedModel } = useAppSelector((state) => state.modelSlice);

  return (
    <>
      <Column height="65vh" overflowY="auto">
        <Table showDividers={true} fixHeaderRows={true} stickyHeaderColumn={true} headerRows={1}>
          <TableRow backgroundColor={meridianColors.colorGray50}>
            {tableHeaderRowNames.map((name) => (
              <TableCell>
                {name === "Insights Generated" ? (
                  <Row spacing={"none"}>
                    <Coachmark popoverPosition="top" animating={false}>
                      <Text>
                        The number represents: number of field extracted by LLM excluding
                        'inadequate' result / number of total field part of this model
                      </Text>
                    </Coachmark>
                    <Text type="h200">{name}</Text>
                  </Row>
                ) : (
                  <Text type="h200">{name}</Text>
                )}
              </TableCell>
            ))}
          </TableRow>
          {isValidRange(firstVisibleIndex, lastVisibleIndex, 0, groundTruthDataListView.length) &&
            _.range(firstVisibleIndex, lastVisibleIndex).map((index) => {
              const totalField = Object.keys(selectedModel.fields).length.toString();
              return (
                groundTruthDataListView[index] && (
                  <TableRow highlightOnHover key={groundTruthDataListView[index].sourceId}>
                    <TableCell>
                      <Link
                        type="secondary"
                        onClick={() => {
                          navigate(
                            `/${navigateUrl}/${getListViewId}/${groundTruthDataListView[index].sourceId}`,
                          );
                        }}
                      >
                        {groundTruthDataListView[index].sourceId}
                      </Link>
                    </TableCell>
                    <TableCell>
                      {getGroundTruthDataListViewStatus(
                        groundTruthDataListView[index],
                        selectedModel,
                        alias,
                      )}
                    </TableCell>
                    <TableCell>
                      {getGroundTruthDataListViewReviewer(groundTruthDataListView[index], alias)}
                    </TableCell>
                  </TableRow>
                )
              );
            })}
        </Table>
      </Column>
      <PaginationWithDropdown
        currentPage={currentPage}
        totalPages={numberOfPages}
        perPage={itemsPerPage}
        setPerPage={(pageNum) => {
          dispatch(setItemPerPage(pageNum));
          dispatch(setCurrentPage(1));
        }}
        setCurrentPage={(newPage) => dispatch(setCurrentPage(newPage))}
      />
    </>
  );
};

export default ListViewTable;
